import { Localized, useLocalization } from '@fluent/react';
import { Textarea } from '@vechaiui/react';

import { DimensionsSpecificationForm } from './DimensionsSpecificationForm';
import { InputFormik } from '#/components/controls/Input';
import { formatTextAsNumberOnly } from '#/utils/formatter';

const CargoDetailsForm: React.FC<CargoDetailsFormProps> = ({ name }) => {
  const namePrefix = name ? `${name}.` : '';
  const { l10n } = useLocalization();

  return (
    <div className="space-y-4">
      <div>
        <Localized id="estimated-weight" attrs={{ placeholder: true }}>
          <InputFormik
            formatter={formatTextAsNumberOnly}
            label={l10n.getString('estimated-weight')}
            name={`${namePrefix}cargoWeight.value`}
            rightAddon={l10n.getString('kilogram').toLowerCase()}
          />
        </Localized>
      </div>

      <div>
        <DimensionsSpecificationForm name={`${namePrefix}cargoDimensions`} />
      </div>
      <p className="pb-2 text-gray-600">*{l10n.getString('cargo-weight-notes')}</p>
      <div>
        <Localized id="cargo-description" attrs={{ placeholder: true }}>
          <InputFormik
            as={Textarea}
            label={l10n.getString('cargo-description')}
            name={`${namePrefix}description`}
          />
        </Localized>
      </div>
    </div>
  );
};
export type CargoDetailsFormProps = {
  name: string;
};

export default CargoDetailsForm;
